"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _base64Url = _interopRequireDefault(require("base64-url"));
module.exports = {
  encode: function encode(v) {
    return _base64Url.default.encode(v);
  },
  decode: function decode(v) {
    return _base64Url.default.decode(v);
  }
};